export default __webpack_public_path__ + "static/media/PLM.9f8e828a.jpg";